import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { FLAVORS, ASSETS } from '../lib/products';

const TILES = [
  { key: 'gifting', title: 'GIFT THE GRIND.', sub: 'GIFT BOXES · EXPLORE OPTIONS · CONTACT US ON WHATSAPP', to: '/gifting', bg: '#7A1E1E', text: '#FFF3D6', img: ASSETS.box50, span: 'md:col-span-2 md:row-span-2 min-h-[320px] md:min-h-0', big: true },
  { key: 'vote', title: 'PICK FLAVOUR #3.', sub: 'SALT & PEPPER · TOMATO · SWEET CHILLI · PUDINA', to: '/vote', bg: '#0B0B0B', text: '#F7B500', img: ASSETS.soon },
  { key: 'mix', title: 'MIX. MATCH. MUNCH.', sub: '50G · ₹50 · 15G PROTEIN · SHOP NOW', to: '/products', bg: '#F7B500', text: '#2A1010', img: FLAVORS['cheese-herbs'].img50 },
];

export default function PromoTiles() {
  return (
    <section data-testid="promo-tiles" className="bg-cream px-5 md:px-14 py-12 md:py-20">
      <div className="max-w-[1500px] mx-auto grid md:grid-cols-3 md:grid-rows-2 gap-5">
        {TILES.map((t, i) => (
          <motion.div key={t.key} className={t.span || 'min-h-[240px]'} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12, duration: 0.6 }}>
            <Link to={t.to} data-testid={`promo-tile-${t.key}`}
              className="group relative rounded-[2rem] overflow-hidden h-full border-2 border-cocoa card-pop grid grid-cols-[1.1fr_1fr] items-center gap-3 p-6 md:p-8" style={{ background: t.bg, color: t.text }}>
              <div className="min-w-0">
                <h3 className={`font-display leading-[0.9] ${t.big ? 'text-5xl md:text-8xl' : 'text-3xl md:text-4xl'}`}>{t.title}</h3>
                <p className="font-cond text-[10px] md:text-xs tracking-[0.2em] mt-3 opacity-80">{t.sub}</p>
                <span className="mt-5 inline-flex items-center gap-2 font-cond font-bold text-xs tracking-[0.2em]">
                  <span className="w-10 h-10 rounded-full border-2 border-current flex items-center justify-center group-hover:bg-cream group-hover:text-cocoa transition-colors duration-300"><ArrowRight size={18} /></span>
                  OPEN
                </span>
              </div>
              <div className={`flex items-center justify-center ${t.big ? 'h-[240px] md:h-[380px]' : 'h-[170px] md:h-[190px]'}`}>
                <img src={t.img} alt="" loading="lazy" className="max-h-full max-w-full object-contain gpu chip-drift" style={{ '--t': `${7 + i}s`, '--r': i % 2 ? '3deg' : '-3deg' }} />
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
